import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appLang: process.env.VUE_APP_LANG
  },
  mutations: {
  },
  actions: {
  },
  getters: {
    getAppLang: state => {
      return state.appLang;
    }
  },
  modules: {
  }
});
